import { MultiSelectOption, Region } from '@dispatch/shared/types';
import { v4 as uuidv4 } from 'uuid';
import { dispatchClient } from '../clients';

const APIM_SERVICE_REGIONS_URL = (tenantId: string) =>
  `configuration/${tenantId}/regions`;

export async function getRegions(tenantId: string) {
  return dispatchClient.get<Region[]>(`${APIM_SERVICE_REGIONS_URL(tenantId)}`, {
    headers: {
      'Request-ID': uuidv4(),
    },
  });
}

export async function getRegionOptions(
  tenantId: string
): Promise<MultiSelectOption[] | undefined> {
  try {
    const response = await dispatchClient.get<Region[]>(
      `${APIM_SERVICE_REGIONS_URL(tenantId)}`,
      {
        headers: {
          'Request-ID': uuidv4(),
        },
      }
    );

    const regions: Region[] = response?.data;
    const regionOptions: MultiSelectOption[] = regions.map((region: Region) => {
      return {
        title: region.name,
        value: region.name,
      };
    });

    if (response.status === 200 && regionOptions) {
      return regionOptions;
    }
  } catch (e) {
    /* eslint-disable no-console */
    console.error('error fetching resources from API', e);
  }
  return undefined;
}

export async function upsertRegion(tenantId: string, postData: Region[]) {
  return dispatchClient.put<Region>(`${APIM_SERVICE_REGIONS_URL(tenantId)}`, [
    ...postData,
  ]);
}
